import {ReactComponent as HomeIcon} from '@deere/ux.brand-foundations/icons/home.svg';
import {ReactComponent as NotificationIcon} from '@deere/ux.brand-foundations/icons/notifications.svg';
import {Dropdown, HeaderButtonBack, HeaderContext, Nav, NavWidget} from '@deere/ux.uxframe-react';
import React from 'react';
import {Link} from 'react-router-dom';
import { SELFSERVICE_ADMIN } from '../utils/surveyLiterals';
import { APP_REDIRECTION } from '../utils/constEnvVariables';
export class TopNav extends React.Component {
    constructor(props) {
        super(props);
        this.handleClick = this.handleClick.bind(this);
    }

  static contextType = HeaderContext;

  handleClick() {
      this.context.onClickLink();
  }

  render() {
      return (
          <React.Fragment>
              <Nav.Item className='uxf-nav-item-icon'>
                  <a
                      aria-label='home page'
                      className='nav-icon'
                      href={APP_REDIRECTION}
                  >
                      <HomeIcon className='nav-home-icon'/>
                  </a>
              </Nav.Item>
              <Dropdown
                  as={Nav.Item}
                  className='active'
              >
                  <Dropdown.Toggle
                      as={Nav.Link}
                      id='currentApp'
                  >
                      <span className='uxf-link-text'>{'CRS'}</span>
                  </Dropdown.Toggle>
                  <Dropdown.Menu renderOnMount={true}>
                      <HeaderButtonBack>{'Menu'}</HeaderButtonBack>
                      <Dropdown.Item
                          as={Link}
                          onClick={this.handleClick}
                          to='/'
                      >{'Search Page'}</Dropdown.Item>
                  </Dropdown.Menu>
              </Dropdown>
              {this.props.userRoles.includes(SELFSERVICE_ADMIN) && (
                <Nav.Item>
                    <Nav.Link as={Link} to="/selfServiceLanding">
                    <span className="uxf-link-text">{"Self-Service"}</span>
                    </Nav.Link>
                </Nav.Item>
              )}
              <Nav.Item>
                  <Nav.Link
                      href={`${APP_REDIRECTION}/applications`}
                      target='_blank'
                  >
                      <span className='uxf-link-text'>{'Applications'}</span>
                  </Nav.Link>
              </Nav.Item>
              <Nav.Item>
                  <Nav.Link
                      href={`${process.env.REACT_APP_CONTACTUS_URL}&USERID=${this.props ? this.props.userId : ""}`}
                      target='_blank'
                  >
                      <span className='uxf-link-text'>{'Contact Us'}</span>
                  </Nav.Link>
              </Nav.Item>
              <Nav.Item className='uxf-nav-item-widget'>
                  <NavWidget value={0}>
                      <NotificationIcon className='notification-active-icon'/>
                  </NavWidget>
              </Nav.Item>
          </React.Fragment>
      );
  }
}
